function syncFrame3ContentScale() {
  const frame = document.querySelector('#frame3');
  if (!frame) return;

  const viewportRatio = window.innerWidth / window.innerHeight;
  const isWideDesktop = window.innerWidth > 768 && viewportRatio > 2.05;
  const fitScale = isWideDesktop ? Math.min(1, 2 / viewportRatio) : 1;
  frame.style.setProperty('--frame3-content-scale', fitScale.toFixed(4));
}

function relayFrame3WheelToParent() {
  // Mobile dùng document flow bình thường; chỉ relay wheel cho Swiper desktop.
  if (window.parent === window || window.matchMedia('(orientation: portrait)').matches) return;

  document.addEventListener('wheel', (event) => {
    if (document.querySelector('.MS__popup.active')) return;
    if (Math.abs(event.deltaY) < Math.abs(event.deltaX) || Math.abs(event.deltaY) < 20) return;

    event.preventDefault();
    window.parent.postMessage({ type: 'main-iframe-wheel', deltaY: event.deltaY }, '*');
  }, { passive: false });
}

class CakeDrawEffect {
  constructor(frame) {
    this.frame = frame;
    this.pieces = Array.from(frame.querySelectorAll('.effect__item'));
    this.runId = 0;
  }

  wait(timeout) {
    return new Promise((resolve) => window.setTimeout(resolve, timeout));
  }

  activate(piece) {
    this.pieces.forEach((item) => {
      item.classList.toggle('MS__active', item === piece);
      item.classList.toggle('MS__off', item !== piece);
    });
  }

  clear() {
    this.runId += 1;
    this.pieces.forEach((item) => item.classList.remove('MS__active', 'MS__off'));
  }

  async run(resultIndex) {
    if (this.pieces.length === 0) return;

    const currentRun = ++this.runId;
    const resultNumber = Number.parseInt(resultIndex, 10) || 1;
    const finalPiece = this.pieces[(resultNumber - 1) % this.pieces.length];

    for (let index = 0; index < 10; index += 1) {
      if (currentRun !== this.runId) return;

      const randomPiece = this.pieces[Math.floor(Math.random() * this.pieces.length)];
      this.activate(randomPiece);
      await this.wait(120);
    }

    if (currentRun !== this.runId) return;
    this.activate(finalPiece);
    await this.wait(420);

    if (currentRun === this.runId) this.clear();
  }
}

function setupCakePromotion(frame, drawEffect, retryCount = 0) {
  const promotion = window.libraryMainsite && window.libraryMainsite.promotion;
  const hasProductionConfig = typeof prodTemplate !== 'undefined';

  if (typeof promotion !== 'function' || !hasProductionConfig) {
    frame.dataset.promotionReady = 'false';

    if (retryCount < 20) {
      window.setTimeout(() => setupCakePromotion(frame, drawEffect, retryCount + 1), 250);
    }
    return;
  }

  frame.dataset.promotionReady = 'true';
  window.libraryMainsite.promotion({
    url: prodTemplate.url,
    debug: prodTemplate.debug,
    directory: prodTemplate.directory,
    items: prodTemplate.items,
    names: prodTemplate.names,
    config: {
      timeWait: 1700,
    },
    animResult: function (listPrize) {
      const firstPrize = Array.isArray(listPrize) ? listPrize[0] : null;
      drawEffect?.run(firstPrize?.indexImg);
    },
    callback: function () {
      drawEffect?.clear();
      if (typeof prodTemplate.fnPromotion === 'function') prodTemplate.fnPromotion();
    },
  });
}

window.addEventListener('load', function () {
  syncFrame3ContentScale();
  relayFrame3WheelToParent();
  const frame = document.querySelector('#frame3');
  const drawEffect = frame ? new CakeDrawEffect(frame) : null;
  const milestones = frame ? Array.from(frame.querySelectorAll('.milestone')) : [];

  function setActiveMilestone(activeMilestone) {
    milestones.forEach((milestone) => {
      const isActive = milestone === activeMilestone;
      milestone.classList.toggle('is-active', isActive);
      milestone.setAttribute('aria-expanded', String(isActive));
    });
  }

  milestones.forEach((milestone) => {
    milestone.setAttribute('role', 'button');
    milestone.setAttribute('aria-expanded', 'false');

    milestone.addEventListener('click', () => {
      setActiveMilestone(milestone.classList.contains('is-active') ? null : milestone);
    });

    milestone.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      milestone.click();
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('#frame3 .milestone')) setActiveMilestone(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setActiveMilestone(null);
  });

  document.querySelectorAll('#frame3 .event-menu-button').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelectorAll('#frame3 .event-menu-button').forEach((item) => {
        item.classList.toggle('is-active', item === button);
      });

      window.dispatchEvent(new CustomEvent('cake-event:panel', {
        detail: { panel: button.dataset.eventPanel },
      }));
    });
  });

  document.querySelectorAll('#frame3 .draw-button').forEach((button) => {
    button.addEventListener('click', () => {
      button.classList.add('is-drawing');
      window.setTimeout(() => button.classList.remove('is-drawing'), 180);
      drawEffect?.run(Number(button.dataset.drawCount) || 1);

      window.dispatchEvent(new CustomEvent('cake-event:draw', {
        detail: { count: Number(button.dataset.drawCount) || 1 },
      }));
    });
  });

  if (frame) setupCakePromotion(frame, drawEffect);
});
window.addEventListener('resize', syncFrame3ContentScale, { passive: true });

function getCombinedFrameName(value) {
  return value === 'frame4' ? 'frame4' : 'frame3';
}

function setCombinedFrameActive(value, shouldNotifyParent = true) {
  const container = document.querySelector('#combined-frame');
  if (!container) return;

  const activeFrame = getCombinedFrameName(value);
  if (container.dataset.activeFrame === activeFrame) return;

  container.dataset.activeFrame = activeFrame;
  window.dispatchEvent(new Event('resize'));

  if (shouldNotifyParent && window.parent !== window) {
    window.parent.postMessage({ type: 'combined-frame-active', frame: activeFrame }, '*');
  }
}

window.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'combined-frame-show') {
    setCombinedFrameActive(event.data.frame);
  }
});

window.addEventListener('hashchange', () => {
  setCombinedFrameActive(window.location.hash.replace('#', ''));
});

window.addEventListener('load', () => {
  const activeFrame = getCombinedFrameName(window.location.hash.replace('#', ''));
  const container = document.querySelector('#combined-frame');
  if (!container) return;

  container.dataset.activeFrame = activeFrame;
  if (window.parent !== window) {
    window.parent.postMessage({ type: 'combined-frame-active', frame: activeFrame }, '*');
  }
});
